'use client';

import * as React from 'react';

/**
 * @ignore - internal component.
 */
const TableContext = /*#__PURE__*/React.createContext();
if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}
export default TableContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Table/TableContext.js
// module id = 891
// module chunks = 22